export default __webpack_public_path__ + "static/media/login.23b5096a.svg";